module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/headers/header-view/header-view.component.scss
// module id = ./src/app/headers/header-view/header-view.component.scss
// module chunks = main